export default __webpack_public_path__ + "static/media/CertificateExcitingIcon.976802db.svg";